module.exports = __webpack_public_path__ + "img/Sven_Wiltsch_2025.a9383e8d.jpg";